module.exports = __webpack_public_path__ + "static/media/19ESCAP12.248f701e.jpg";